import { Component, OnInit, OnDestroy } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { AppComponent } from '../../../app.component';
import { AssociadoService } from '../../../core/services/associado.service';
import { Associado } from '../../../shared/models/associado';

@Component({
  selector: 'app-associado-resumo',
  templateUrl: './associado-resumo.component.html',
  styleUrls: ['./associado-resumo.component.css']
})
export class AssociadoResumoComponent implements OnInit, OnDestroy {
  associado: Associado;
  carregando = false;
  erro = '';
  private rota: Subscription;
  private consulta: Subscription;

  constructor(private route: ActivatedRoute, private service: AssociadoService,
              private app: AppComponent, private location: Location) {}

  ngOnInit(): void {
    this.app.setTitulo('Visualizar Cadastro');
    this.app.setBreadcrumb([{ nome: 'Associados', caminho: '/associado-listar' }]);
    document.body.classList.add('pagina-resumo-cadastro');
    this.rota = this.route.paramMap.subscribe(params => {
      if (this.consulta) { this.consulta.unsubscribe(); }
      this.associado = null;
      this.erro = '';
      this.carregando = false;
      const codigo = Number(params.get('id'));
      if (!Number.isSafeInteger(codigo) || codigo <= 0) {
        this.erro = 'Cadastro inválido.';
        return;
      }
      this.carregando = true;
      this.consulta = this.service.find(codigo).subscribe((data: Associado) => {
        this.carregando = false;
        if (!data || !data.codigo_pessoa || !data.pessoa) {
          this.erro = 'Cadastro não encontrado.';
          return;
        }
        this.associado = data;
      }, () => {
        this.carregando = false;
        this.erro = 'Não foi possível carregar o cadastro. Tente novamente.';
      });
    });
  }

  voltar(): void { this.location.back(); }
  imprimir(): void { window.print(); }

  ngOnDestroy(): void {
    if (this.consulta) { this.consulta.unsubscribe(); }
    if (this.rota) { this.rota.unsubscribe(); }
    document.body.classList.remove('pagina-resumo-cadastro');
  }
}
